<script setup>

const use_ws_button = process.env.VUE_APP_BRAND_NAME && process.env.VUE_APP_BRAND_NAME == 'WSBetting' ? true : false;
</script>

<template>
    <svg v-if="use_ws_button" class="event-field-live-svg" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 150 150">

        <path d="M103.026,71.389l-38.048-27.658c-1.396-1.012-3.25-1.165-4.78-.378-1.543.78-2.506,2.366-2.506,4.079v55.298c0,1.732.963,3.311,2.506,4.091.652.329,1.366.494,2.085.494.939,0,1.89-.299,2.695-.89l38.048-27.634c1.201-.884,1.902-2.25,1.902-3.701.006-1.476-.713-2.835-1.902-3.701Z"/>
        <path d="M75.002,7.044C37.459,7.044,7.035,37.468,7.035,75.011s30.424,67.944,67.967,67.944,67.962-30.419,67.962-67.944c.005-37.543-30.428-67.967-67.962-67.967ZM75.002,131.616c-31.265,0-56.613-25.335-56.613-56.604s25.348-56.622,56.613-56.622,56.604,25.362,56.604,56.622c.005,31.269-25.344,56.604-56.604,56.604Z"/>
    </svg>

    <svg v-else xmlns="http://www.w3.org/2000/svg" width="50px" height="34px"
        viewBox="0 0 50 34" fill="none"
        style="height:17px; shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd">
        <rect x="1" y="1" width="48" height="32" rx="4" ry="4" class="border" />
        <polygon points="19,8.5 34,17 19,25.5" class="play-fill" />
    </svg>
</template>

<style scoped>

.event-field-live-svg {
    cursor: pointer;
    height: 22px;
    fill:#d3a11d;
    opacity: 0.5;
    /* fill: var(--border-light); */
}

.event-field-live-svg:hover {
    opacity: 1;
}

.video-icon-selected .event-field-live-svg {
    opacity: 1;
}


.play-fill {
	fill: var(--border-light);
}

.border {
	fill: none;
	stroke: var(--border-light);
	stroke-width: 1;
}

.video-icon {
	width: 25px;
	height: 17px;
}

.field-icon-container:hover .play-fill {
	fill: var(--primary);
}

.field-icon-container:hover .border {
	stroke: var(--primary);
}

.video-icon-selected .play-fill {
	fill: var(--primary);
}

.video-icon-selected .border {
	stroke: var(--primary);
}


</style>